import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { take } from 'rxjs/operators';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { ApiError, MessageService } from '../../../../../core';
import { PacoteCampanhaSearchOrderBy } from '../../pacote-campanha-search-orderby';
import { PacoteCampanhaFilter } from '../../filter/pacote-campanha-filter';
import { PacoteCampanhaSearchHttpService } from '../../services';
import { pacoteCampanhaSituacaoAtivo } from '../../situacao';
import { AreaPacoteCampanhaSelect, createAreasPacotesSelect } from '../../select';

@Component({
    selector: 'sgt-pacote-campanha-multiselect',
    templateUrl: './pacote-campanha-multiselect.component.html',
    styleUrls: ['./pacote-campanha-multiselect.component.less']
})
export class PacoteCampanhaMultiselectComponent implements OnInit, OnDestroy {
    /** Pacotes selecionados */
    @Input() idsPacotes: number[];
    /** Ao alterar a seleção dos pacotes */
    @Output() idsPacotesChange = new EventEmitter<number[]>();

    /** Se deve exibir a opção de selecionar a opção de pacote nulo ou seja, para filtrar registros que não possuem o pacote */
    @Input() showNullOption = false;
    /** Valor da opção de selecionar o pacote nulo */
    @Input() nullOption = false;
    /** Ao alterar a seleção da opção do pacote nulo */
    @Output() nullOptionChange = new EventEmitter<boolean>();

    /** Input Name */
    @Input() nameSomenteAtivos = 'multiselectPacoteCampanhaSomenteAtivos';
    /** Input ID */
    @Input() idSomenteAtivos = 'multiselectPacoteCampanhaSomenteAtivos';
    /** Se deve filtrar somente os pacotes ativos */
    @Input() somenteAtivos = true;
    @Output() somenteAtivosChange = new EventEmitter<boolean>();

    /** Ao destruir o multiselect */
    @Output() onDestroy = new EventEmitter<void>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todos';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhum pacote';
    @Input() checked = 'Pacote';
    @Input() checkedPlural = 'Pacotes';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todos Selecionados';
    @Input() searchEmptyResult = 'Nenhum pacote encontrado';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    areasPacotes: AreaPacoteCampanhaSelect[];

    constructor(private messageService: MessageService,
                private pacoteCampanhaSearchHttpService: PacoteCampanhaSearchHttpService) { }

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-pacote-campanha ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.search();
    }


    toggleSomenteAtivos(value: boolean) {
        this.somenteAtivos = value;
        this.somenteAtivosChange.emit(this.somenteAtivos);
        this.search();
    }

    /** Cria o filter para pesquisar os pacotes de campanhas */
    private createFilter(): PacoteCampanhaFilter {
        const filter = new PacoteCampanhaFilter();

        // Somente ativos
        if (this.somenteAtivos) {
            filter.situacoes = [pacoteCampanhaSituacaoAtivo.id];
        }

        return filter;
    }

    /** Cria os pacotes para o multiselect */
    private search() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        const filter  = this.createFilter();
        this.pacoteCampanhaSearchHttpService.search(filter, PacoteCampanhaSearchOrderBy.NomeArea, 'asc', -1, -1)
            .pipe(
                take(1)
            )
            .subscribe(
                pacotes => {
                    this.areasPacotes = createAreasPacotesSelect(pacotes);

                    // Adicionando as áreas e seus pacotes ao multiselect
                    if (this.areasPacotes) {
                        // Adicionando a opção de "Sem Pacote"
                        if (this.showNullOption) {
                            selects.push({
                                id: 0,
                                name: 'SEM PACOTE'
                            });
                        }

                        // Áreas
                        this.areasPacotes.forEach(area => {
                            // Área
                            selects.push({
                                id: area.id,
                                name: area.nome,
                                isLabel: true
                            });
                            // Pacotes
                            area.pacotes?.forEach(pacote => {
                                selects.push({
                                    id: pacote.id,
                                    name: pacote.nome
                                });
                            });
                        });
                        this.options = selects;
                    }
                },
                (error: ApiError) => {
                    this.messageService.error(error.message,  'Erro ao pesquisar os pacotes', error);
                }
            );
    }


    /** Ao alterar a seleção da opção pacote nulo */
    private onChangeNullOption() {
        this.nullOption = this.idsPacotes.includes(0);
        this.nullOptionChange.emit(this.nullOption);

    }

    /** Ao alterar a seleção dos pacotes */
    onChange() {
        this.onChangeNullOption();
        this.idsPacotesChange.emit(this.idsPacotes);
    }

    ngOnDestroy() {
        this.onDestroy.emit();
    }
}
